import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useFormContext } from 'react-hook-form';
import { Card, CardActionsButtons } from 'shared/mui/Card';
import { FilterApplyButton } from 'shared/mui/Filter/FilterButtons';
import { Popover, PopoverProps } from 'shared/mui/Popover/Popover';

import { PopoverContentStyled } from './PopoverChip.styled';
import { PopoverChipFilterResetButton } from './PopoverChipFilterResetButton/PopoverChipFilterResetButton';

type PopoverChipProps = PopoverProps & {
  onApply: () => void;
  onReset: () => void;
};

export const PopoverChip: React.FC<PopoverChipProps> = ({
  children,
  onApply,
  onReset,
  ...restProps
}) => {
  const translate = useTypedTranslate();
  const { formState } = useFormContext();

  return (
    <Popover
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      {...restProps}
    >
      <Card>
        <PopoverContentStyled>{children}</PopoverContentStyled>
        <CardActionsButtons
          leftActionsSlot={[
            <FilterApplyButton
              disabled={!formState.isValid}
              key="apply-button"
              onClick={onApply}
            />,
            <PopoverChipFilterResetButton
              key="reset-button"
              label={translate('app.buttons.cancel')}
              onClick={onReset}
            />,
          ]}
          sx={{
            padding: '16px 24px',
          }}
        />
      </Card>
    </Popover>
  );
};
